/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { KS_customerservice_Service_Clients_M2MConnector_UserDto } from '../models/KS_customerservice_Service_Clients_M2MConnector_UserDto';
import type { KS_customerservice_Service_Clients_M2MConnector_UserDtoPagedResult } from '../models/KS_customerservice_Service_Clients_M2MConnector_UserDtoPagedResult';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class M2MService {

    /**
     * @returns KS_customerservice_Service_Clients_M2MConnector_UserDto OK
     * @throws ApiError
     */
    public static getApiM2MUsers(): CancelablePromise<Array<KS_customerservice_Service_Clients_M2MConnector_UserDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/m2m/users',
        });
    }

    /**
     * @param companyTaxNumber 
     * @param skip 
     * @param top 
     * @param continuationToken 
     * @returns KS_customerservice_Service_Clients_M2MConnector_UserDtoPagedResult OK
     * @throws ApiError
     */
    public static getApiV1M2MUsers(
companyTaxNumber?: string,
skip?: number,
top?: number,
continuationToken?: string,
): CancelablePromise<KS_customerservice_Service_Clients_M2MConnector_UserDtoPagedResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/m2m/users',
            query: {
                'CompanyTaxNumber': companyTaxNumber,
                'Skip': skip,
                'Top': top,
                'ContinuationToken': continuationToken,
            },
        });
    }

}
